export function formatDate(value?: string | null, options?: Intl.DateTimeFormatOptions) {
  if (!value) return '—'
  const normalized = /^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00` : value
  return new Intl.DateTimeFormat('pt-BR', options || { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(normalized))
}

export function formatTime(value?: string | null) {
  if (!value) return '—'
  if (/^\d{2}:\d{2}/.test(value)) return value.slice(0, 5)
  return new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit' }).format(new Date(value))
}

export function formatDateTime(value?: string | null) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }).format(new Date(value))
}

export function formatMoney(value?: number | null) {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value || 0)
}

export function ageFrom(value: string) {
  const today = new Date()
  const birth = new Date(`${value.slice(0, 10)}T12:00:00`)
  let age = today.getFullYear() - birth.getFullYear()
  if (today.getMonth() < birth.getMonth() || (today.getMonth() === birth.getMonth() && today.getDate() < birth.getDate())) age--
  return age
}

export function humanize(value?: string | null) {
  if (!value) return '—'
  const text = value.toLocaleLowerCase('pt-BR').replaceAll('_', ' ')
  return text.charAt(0).toLocaleUpperCase('pt-BR') + text.slice(1)
}

